// A trade evaluation is a wall of signed numbers. These helpers keep the sign
// convention consistent everywhere: positive is a gain for the team in view.

export function signedPoints(value) {
  if (value === null || value === undefined) return '—'
  const rounded = Number(value).toFixed(1)
  return value > 0 ? `+${rounded}` : rounded
}

export function signedPercent(value) {
  if (value === null || value === undefined) return '—'
  const points = Number(value) * 100
  const rounded = points.toFixed(1)
  return points > 0 ? `+${rounded}%` : `${rounded}%`
}

export function percent(value) {
  if (value === null || value === undefined) return '—'
  return `${(Number(value) * 100).toFixed(1)}%`
}

export function points(value) {
  if (value === null || value === undefined) return '—'
  return Number(value).toFixed(1)
}

export function adp(value) {
  if (value === null || value === undefined) return 'undrafted'
  return Number(value).toFixed(1)
}

// Reads the validated diverging tokens from application.css rather than
// hardcoding a hue, so light/dark swap in one place.
export function deltaClass(value, { neutral = 'text-slate-500 dark:text-slate-400' } = {}) {
  if (!value) return neutral
  return value > 0 ? 'text-[var(--gain)]' : 'text-[var(--loss)]'
}

// Sleeper's format keys are wire values, not labels. "half_ppr" should never
// reach a human.
const FORMAT_LABELS = {
  std: 'Standard',
  half_ppr: '½ PPR',
  ppr: 'Full PPR',
  '2qb': 'Superflex',
  dynasty_std: 'Dynasty Standard',
  dynasty_half_ppr: 'Dynasty ½ PPR',
  dynasty_ppr: 'Dynasty Full PPR',
  dynasty_2qb: 'Dynasty Superflex',
}

export function formatLabel(key) {
  if (!key) return ''
  return FORMAT_LABELS[key] ?? key
}
